import { Box, Skeleton, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import AssessmentBlockItems from '../../../components/V2/BlockItem/Contest/AssessmentBlockItems';
import ResourceBlockItems from '../../../components/V2/BlockItem/Resource/ResourceBlockItems';
import LectureBlockItems from '../../../components/V2/BlockItem/Lecture/LectureBlockItems';
import { useBlockItems } from '../../../hooks/V2/useCourse';

const BlockItemsPage = () => {
	const blockId = useSearchParams()[0].get('blockId') || '';
	const blockItemType = useSearchParams()[0].get('type') || '';

	const { data: blockItems, refetch: reftechBlockItems, isLoading } = useBlockItems(blockId, blockItemType);

	useEffect(() => {
		if (blockId) {
			reftechBlockItems();
		}
	}, [blockId, reftechBlockItems]);

	useEffect(() => {
		if (blockItemType) {
			reftechBlockItems();
		}
	}, [blockItemType, reftechBlockItems]);

	const getBlockItemTypeComponent = () => {
		if (blockItemType === 'contest') return <AssessmentBlockItems blockItems={blockItems} assessmentType="contest" />;
		if (blockItemType === 'resource') return <ResourceBlockItems blockItems={blockItems} />;
		if (blockItemType === 'quiz') return <AssessmentBlockItems blockItems={blockItems} assessmentType="quiz" />;
		if (blockItemType === 'lecture') return <LectureBlockItems blockItems={blockItems} />;
	};
	const getLabel = () => {
		if (blockItemType === 'contest') return 'Contests';
		if (blockItemType === 'resource') return 'Cheatsheets';
		if (blockItemType === 'quiz') return 'Quizzes';
		if (blockItemType === 'lecture') return 'Masterclass';
	};

	return (
		<Skeleton isLoaded={!isLoading} p="16px" h="full">
			<Text textStyle={'body1-md'} color="#0A0103" mb="16px">
				{getLabel()}
			</Text>
			{getBlockItemTypeComponent()}
		</Skeleton>
	);
};

export default BlockItemsPage;
